import React, {
  Suspense,
  memo,
  useCallback,
  useMemo,
  useState,
  useLayoutEffect,
} from "react";
import cn from "classnames";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import Loader from '@components/common/Loader/newLoaderModal';
import { ReactComponent as BackChevron } from "@assets/images/backChevron.svg";
import { ReactComponent as Plus } from "@assets/images/plus.svg";
import { ReactComponent as Minus } from "@assets/images/minus.svg";
import { CUSTOM_MESSAGES, LABEL } from "../../../veriables";
import styles from "../serverAppPaymentScreens.module.scss";
import style from "./index.module.scss";
import { TouchableButton } from '@components/common/Touchable'
import LoyaltyListPopUp from "../../../containers/ViewReceipt/loyaltyListPopUp";
import NotesIcon from '@assets/images/NotesIcon';
import { getObjectValue } from "@utility/utills";
import { setFromPay } from "../../../reducers/orders";
const SplitEvenly = ({
  serverAppTheme,
  handleBackButtonClick,
  paymentAmount,
  handleStagePaymentSubmit,
  tableData,
  currenySymbol,
  isOrderingPortrait,
  ...props
}) => {
  const [count, setCount] = useState(2);
  const [selectedLoyalty, setSelectedLoyalty] = useState([]);
  const [openLoyalty, setOpenLoyalty] = useState(false);

  const itemData = useMemo(
    () => [
      ...(props.seat?.items || []),
      ...(props.seat?.discounts || []),
      ...(props.seat?.serviceCharges || []),
    ],
    [props.seat?.items, props.seat?.discounts, props.seat?.serviceCharges]
  );

  const splitEvenlyStyles = useMemo(() => {
    const ulBg = {
      background: serverAppTheme?.tip_tile,
    }
    const liBg = {
      color: serverAppTheme?.primary_text,
    }
    const downArrow = {
      color: serverAppTheme?.modifier_arrowDown,
    }
    const notes = {
      color: serverAppTheme?.notes,
    }
    const payBtn = {
      background: serverAppTheme?.enabledPayBtn,
      color: serverAppTheme?.btn_font_color,
    }
    const backArrow = {
      backgroundColor: serverAppTheme?.iconcolor_bg_box,
    }
    const leftScreen = {
      color: serverAppTheme?.primary_text,
      backgroundColor: serverAppTheme?.subTotalBg,
    }
    const saveBtn = {
      background: serverAppTheme?.primaryBtn,
      color: serverAppTheme?.btn_font_color,
    }
    const incDecBtn = {
      background: serverAppTheme?.primaryBtn,
      color: serverAppTheme?.btn_font_color,
    }
    return { ulBg, liBg, downArrow, notes, payBtn, backArrow, leftScreen, saveBtn, incDecBtn };
  }, [serverAppTheme]);

  useLayoutEffect(() => {
    const seatObject = getObjectValue(() => JSON.parse(window.sessionStorage.getItem("seat")), {});

    const splitCount = seatObject?.splits || [];
    const seat = seatObject?.seats || [];
    
    if (splitCount?.length === 0) {
      setCount(seat?.filter((e) => e?.open)?.length);
    } else if (splitCount?.length < 2) {
      setCount(seat?.length);
    } else {
      setCount(splitCount?.length);
    }
  }, []);

  // for sending loyalty id in payload of split evenly screen
  const handleLoyaltyArray = (data) => {
    let arr = [];
    if (data) {
      data.map(e => {
        arr.push(e.id);
      });
    }
    return arr;
  };

  // for adding multiple items in an array
  const addToSplitEvenlyArr = (data) => {
    if (!selectedLoyalty.includes(data?.id) && selectedLoyalty?.length !== count) {
      setSelectedLoyalty(prev => [...prev, data.id]);
    } else if (selectedLoyalty.includes(data?.id)) {
      const filteredData = selectedLoyalty?.filter(e => e !== data?.id);
      setSelectedLoyalty(filteredData);
    }
  };

  const handlePayment = useCallback(
    (isCross) => {
      const payload = {
        deviceId: props?.deviceInfo?.deviceId,
        employeeId: props?.seat?.employeeId,
        storeId: props?.deviceInfo?.storeId,
        checkHeaderId: props?.seat?.id,
        splitType: 3,
        splitValue: count,
        loyalties:
          (props.seat.loyalties.length <= count && selectedLoyalty.length === 0)
            ? handleLoyaltyArray(props.seat.loyalties)
            : selectedLoyalty,
      };

      handleStagePaymentSubmit({
        payload: payload,
        isSplitEvenly: true,
        isCross,
      });
    },
    [count, props?.deviceInfo, props?.seat, handleStagePaymentSubmit, selectedLoyalty]
  );

  const renderModifier = useCallback(
    (modifiersObj, n, nest) => (
      <ul
        className={cn("col-12 pl-2 m-0 fs_12 rounded pb-2 pr-0")}
        style={{ listStyle: "none", ...splitEvenlyStyles.ulBg }}
      >
        {modifiersObj.map((modifier, index) => {
          return (
            <li
              className={cn(
                "col-12 px-0 w-99",
                modifier?.price === 0 && "d-none",
              )}
              style={{ color: nest ? serverAppTheme?.primary_text : "#5081DE" }}
              key={modifier?.modifierId}
            >
              <div
                className={cn(
                  "col-12 mt-1 mx-0 px-0 row w-99",
                  !(nest && index === 1) && "mt-1",
                )}
              >
                {modifier?.quantity > 1 && (
                  <span className="col-1 px-0 m-0 va-tt">
                    <u>{modifier?.quantity}</u> <span>x</span>{" "}
                  </span>
                )}
                <div
                  className={cn(
                    "px-0 col-9",
                    
                  )}
                >
                  {modifier?.modifierName}
                </div>
                {modifier?.price && (
                  <div className="col-3 pl-1">
                    {LABEL().CURRENCY_SYMBOL}
                    {modifier?.price?.toFixed(2)}
                  </div>
                )}
              </div>
              {(modifier.note || modifier.comment) && (
                <div className={cn("col-12 row mx-0 px-0 fs-12")}>
                  <span className='col-1 px-0'>
                    <NotesIcon />
                  </span>
                  <span className={cn('pl-2 col-11 pr-0')} style={{color: "#000"}}>
                    {modifier.note || modifier.comment}
                  </span>
                </div>
              )}
              {modifier?.modifiers && modifier?.modifiers?.length > 0 && (
                <div className="d-flex col-12 px-0 w-95">
                  <div
                    className={cn("fs_20", style.hyphenStyle)}
                    style={splitEvenlyStyles.downArrow}
                  >
                    -
                  </div>
                  <div className="col-12 px-0 pl-0 mt-2 fs_10">
                    {renderModifier(modifier?.modifiers, n, true)}
                  </div>
                </div>
              )}
            </li>
          );
        })}
      </ul>
    ),
    [serverAppTheme],
  );

  const ItemList = useCallback(
    (items) => {
      return items.length > 0 ? (
        items.map((i, index) => {
          return (
            <div
              className={cn(
                "col-12 d-flex fs_16 fw-500 m-0 mb-1 p-0 rounded row",
              )}
            >
              <div
                className={cn("col-12 p-0 rounded")}
                style={splitEvenlyStyles.ulBg}
              >
                <div
                  className={cn("col-12 p-0 m-0 py-2 d-flex rounded")}
                  style={splitEvenlyStyles.liBg}
                  role="presentation"
                >
                  {i?.discountId ? (
                    <div className={cn("pl-2", isOrderingPortrait ? 'col-5 fs_12 fw-400' : 'col-7')}>{i.discountName}</div>
                  ) : i?.serviceChargeId ? (
                    <div className={cn("pl-2", isOrderingPortrait ? 'col-5 fs_12 fw-400' : 'col-7')}>{i?.serviceChargeName}</div>
                  ) : (
                    <div className={cn("pl-2", isOrderingPortrait ? 'col-5 fs_12 fw-400' : 'col-7')}>{i?.menuItemName}</div>
                  )}
                  <div className={cn("text-center px-0 ", isOrderingPortrait ? 'col-3  fs_12 fw-400' : 'col-2 fw-500')}>
                    {i.seats &&
                      i.seats.length > 0 &&
                      i.seats[0].splitValue > 1 &&
                      i.quantity
                      ? `${i.quantity}/${i.seats[0].splitValue}`
                      : i.quantity}
                  </div>
                  {i?.discountId ? (
                    <div className="col-3 fs_12 fw-400 p-0 text-right pr-2">
                      -{currenySymbol}
                      {i?.value?.toFixed(2)}
                    </div>
                  ) : (
                    <div className={cn("col-3 text-right", isOrderingPortrait ? 'pl-4 fs_12 fw-400' : 'pr-2')}>
                      {currenySymbol}
                      {i?.price?.toFixed(2)}
                    </div>
                  )}
                </div>
                {i.modifiers &&
                  i.modifiers.length > 0 &&
                  renderModifier(i.modifiers)}
                {(i.note || i.comment) && (
                  <div className={cn("col-12 row mx-0 px-0 fs-12 pl-2")}>
                    <span className='col-1 px-0'>
                      <NotesIcon />
                    </span>
                    <span className={cn('pl-2 col-11 pr-0')} style={{color: "#000"}}>
                      {i.note || i.comment}
                    </span>
                  </div>
                )}
              </div>
            </div>
          );
        })
      ) : (
        <div className="h-100 fs-20 row mx-0 align-items-center justify-content-center">
          {CUSTOM_MESSAGES().NO_ITEM_FOUND}
        </div>
      );
    },
    [serverAppTheme, currenySymbol, renderModifier],
  );

  const PayButton = memo(({ onClick }) => (
    <TouchableButton
      type="button"
      className={cn(
        "col-12  px-1 btn-ripple", isOrderingPortrait ? 'mb-4 btn68' : `${styles.splitEvenlyPayBtn} mt-2 btn44`,
      )}
      style={splitEvenlyStyles.payBtn}
      onClick={(e) => {
        props.setFromPay(true);
        e.preventDefault();
        count < props?.seat?.loyalties?.length
          ? setOpenLoyalty(true)
          : handlePayment();
      }}
      rippleEffect={true}
    >
      {LABEL().PAY}
    </TouchableButton>
  ));

  const handleSplitEvenly = () => {
    if(selectedLoyalty?.length !== count || selectedLoyalty?.length === 0){
      props.setErrorPopUp({
        res: `${LABEL().SE_ERR_MUST_SELECT} ${count} ${LABEL().SE_ERR_LOYALTY_ACCOUNT}`,
        noErrorTxt: true,
      });
    } else {
      handlePayment();
      setOpenLoyalty(false);
      setSelectedLoyalty([]);
    }
  };

  return (
    <Suspense fallback={<Loader />}>
      <>
        {/* 1. Back button */}
        <div
          className={cn(
            "position-fixed d-flex justify-content-center align-items-center rounded",
            styles.splitEvenlyBackArrow,
          )}
          style={splitEvenlyStyles.backArrow}
        >
          <BackChevron
            fill={serverAppTheme?.iconcolor}
            alt=""
            onClick={() => {
              handleBackButtonClick();
            }}
          />
        </div>
        {/* 2. split enenly text */}
        <div
          className={cn("col-12 position-fixed text-center", isOrderingPortrait ? 'fs_18 ' : 'fs_20', styles.splitEvenlyText)}
        >
          {LABEL().LS_SPLIT_EVENLY}
        </div>
        {/* 3. Split Evenly Screen*/}
        <div className={cn("col-12 px-0 d-flex", styles.topPadding)}>
          {/* 3.1 Left Screen */}
          <div
            className={cn(
              "overflowY position-relative rounded", isOrderingPortrait ? 'col-6 px-2' : `${styles.heightOfLeftContainer} col-8 px-0`,
            )}
            style={splitEvenlyStyles.leftScreen}
          >


            {/* text */}
            <div
              className={cn(
                "col-12  d-flex justify-content-center align-items-center mx-auto text-center fw-600 pt-5",
                isOrderingPortrait ? 'px-0 fs_20 mt-3' : `${styles.divForSplitEvenly}`
              )}
            >
              {LABEL().HOW_MANY_WILL_BE_SPLITTING
                ? LABEL().HOW_MANY_WILL_BE_SPLITTING
                : CUSTOM_MESSAGES().SPLITTING_MESSAGE}
            </div>
            {/* + - buttons */}
            <div className={cn("col-12" ,isOrderingPortrait ? 'pt-20' : 'pt-12')}>
              <div
                className={cn("row align-items-center justify-content-center")}
              >
                <TouchableButton
                  className={cn(
                   isOrderingPortrait ? styles.PortraitincDecButtonCopy : styles.incDecButtonCopy,
                    styles.btnRounded,
                    "d-flex justify-content-center align-items-center fs_32", isOrderingPortrait ? 'mr-4' : 'mx-5'
                  )}
                  style={splitEvenlyStyles.incDecBtn}
                  role="presentation"
                  onClick={() =>
                    count !== 1 && count !== 2 && setCount(count - 1)
                  }
                  rippleEffect={true}
                >
                  <Minus fill="white" alt="" />
                </TouchableButton>
                <div
                  className={cn("num" ,isOrderingPortrait ? 'fs_40 fw-600' :'fs_96 fw-300')}
                >
                  {" "}
                  {count}{" "}
                </div>
                <TouchableButton
                  className={cn(
                    isOrderingPortrait ? styles.PortraitincDecButtonCopy : styles.incDecButtonCopy,
                    styles.btnRounded,
                    "d-flex justify-content-center align-items-center fs_32",isOrderingPortrait ? 'ml-4' : 'mx-5'
                  )}
                  style={splitEvenlyStyles.saveBtn}
                  role="presentation"
                  onClick={() => setCount(count + 1)}
                  rippleEffect={true}
                >
                  <Plus fill="white" alt="" />
                </TouchableButton>
              </div>
            </div>
            {/* text and amount */}
            <div className={cn("col-12" ,isOrderingPortrait ? 'pt-30' : 'pt-20')}>
              <div
                className={cn(
                  "d-flex justify-content-center",isOrderingPortrait ? 'fs_24 fw-400' : styles.divForSplitEvenly,
                )}
              >
                {CUSTOM_MESSAGES().EACH_PAY}
              </div>
              <div
                className={cn(
                  "col-12 text-center",
                 isOrderingPortrait ? 'fs_40 fw-500' :  styles.amountStyleSpliEvenly,
                )}
              >
                {LABEL().CURRENCY_SYMBOL}
                {Number(paymentAmount / count).toFixed(2)}{" "}
              </div>
            </div>
            {/* save button */}
            <TouchableButton
              className={cn(
                 "position-absolute align-content-center fs_16 text-center rounded border-0 col-3 px-0",
                 styles.saveSplitEvenly
              )}
             style={{
                ...splitEvenlyStyles.saveBtn,
                borderRadius: "4px",
                border: "none",
                fontSize: "16px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onClick={(e) => {
                props.setFromPay(false);
                e.preventDefault();
                count < props?.seat?.loyalties?.length
                  ? setOpenLoyalty(true)
                  : handlePayment(true);
              }}
              rippleEffect={true}
            >
              {LABEL().SAVE}
            </TouchableButton>
          </div>
          {/* 3.2 Right Screen */}
          <div className={cn("pl-2 pr-0", isOrderingPortrait ? `${style.h81} col-6` : `${styles.splitEvenlyRightScreen} col-4`)}>
            <div
              className={cn("col-12 d-flex p-0 pb-1", styles.itemsStyle)}
              style={{
                color: serverAppTheme?.itemQtyClr,
              }}
            >
              <div className={cn("pl-2", isOrderingPortrait ? 'col-5 fs_12 fw-500' : 'col-7')}>{LABEL()?.RECEIPT_ITEMS}</div>
              <div className={cn(" text-center", isOrderingPortrait ? 'col-4 pl-2 fs_12 fw-500' : 'col-2 p-0')}>{LABEL().QTY}</div>
              <div className={cn("col-3 p-0 text-right pr-2", isOrderingPortrait ? 'fs_12 fw-500' : '')}>{LABEL().AMOUNT}</div>
            </div>

            <div className={cn("mx-0 rounded", isOrderingPortrait ? 'h-100' : styles.splitEvenlyItems)}>
              <div className={cn("overflowXHidden overflowY", isOrderingPortrait ? 'h-98' : 'h-85')}>
                {tableData?.items &&
                  tableData?.items?.length > 0 &&
                  ItemList(itemData)}
              </div>
              <div className={cn("w-100 h-15 d-flex justify-content-around", isOrderingPortrait ? 'mt-2' : '')}>
                <PayButton onClick={() => handlePayment()} />
              </div>
            </div>
          </div>
        </div>
        {openLoyalty && (
          <LoyaltyListPopUp
            openLoyalty={openLoyalty}
            setOpenLoyalty={setOpenLoyalty}
            serverAppTheme={serverAppTheme}
            seat={props?.seat}
            loyaltyList={props?.seat?.loyalties}
            setSelectedLoyalty={setSelectedLoyalty}
            handleLoyaltySubmit={handleSplitEvenly}
            selectedLoyalty={selectedLoyalty}
            isSplitEvenly
            addToSplitEvenlyArr={addToSplitEvenlyArr}
            count={count}
            fromPay={props.fromPay}
          />
        )}
      </>
    </Suspense>
  );
};

const mapStateToProps = ({ oauth, orders }) => ({
  deviceInfo: oauth.deviceInformation,
  seat: orders.seats,
  fromPay: orders.fromPay
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setFromPay
    },
    dispatch
  );

export default memo(connect(mapStateToProps, mapDispatchToProps)(SplitEvenly));
